import React from 'react';
import { List, ListItem, ListItemText, Typography, Box, Chip } from '@mui/material';

const TicketList = ({ tickets, selectedTicket, onTicketSelect }) => {
  // Sort tickets by price in ascending order
  const sortedTickets = [...tickets].sort((a, b) => a.price - b.price);

  return (
    <List>
      {sortedTickets.map((ticket) => (
        <ListItem
          key={ticket.id}
          onClick={() => ticket.quantity > 0 && onTicketSelect(ticket)}
          sx={{
            mb: 2,
            border: '1px solid',
            borderColor: selectedTicket?.id === ticket.id ? 'primary.main' : 'divider',
            borderRadius: 2,
            cursor: ticket.quantity > 0 ? 'pointer' : 'not-allowed',
            backgroundColor: selectedTicket?.id === ticket.id ? 'action.selected' : 'inherit',
            opacity: ticket.quantity > 0 ? 1 : 0.8,
            '&:hover': {
              backgroundColor: ticket.quantity > 0 ? 'action.hover' : 'inherit',
            },
            position: 'relative',
            overflow: 'hidden',
          }}
        >
          {ticket.quantity === 0 && (
            <Box
              sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%) rotate(-45deg)',
                backgroundColor: 'error.main',
                color: 'error.contrastText',
                padding: '5px 50px',
                fontSize: '1.2rem',
                fontWeight: 'bold',
                zIndex: 1,
                boxShadow: '0 0 10px rgba(0,0,0,0.5)',
              }}
            >
              SOLD OUT
            </Box>
          )}
          <ListItemText
            primary={
              <Typography variant="subtitle1" color="primary" sx={{ fontWeight: 'bold' }}>
                {ticket.name}
              </Typography>
            }
            secondary={
              <Box sx={{ mt: 1 }}>
                <Typography variant="body2" color="text.primary">
                  {ticket.details.description}
                </Typography>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 1 }}>
                  <Typography variant="body1" color="primary.main" sx={{ fontWeight: 'bold' }}>
                    Price: ${ticket.price}
                  </Typography>
                  {ticket.quantity > 0 && (
                    <Chip 
                      label={`Available: ${ticket.quantity}`} 
                      color="success" 
                      size="small"
                      sx={{ fontWeight: 'bold' }}
                    />
                  )}
                </Box>
              </Box>
            }
          />
        </ListItem>
      ))}
    </List>
  );
};

export default TicketList;